import { useDispatch, useSelector } from "react-redux";
import React, { FC, useEffect, useRef, useState } from "react";
import moment from "moment/moment";
import {
  Badge,
  ButtonGroup,
  Button,
  Table,
  Form,
  FormGroup,
  UncontrolledCollapse,
  CardHeader,
  Label,
  Collapse,
  Input,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  CardImg,
  Container,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Row,
  Col,
  UncontrolledTooltip,
  Spinner,
} from "reactstrap";
import {
  BrowserRouter,
  Switch,
  Route,
  useParams,
  useLocation,
  useHistory,
} from "react-router-dom";
import { Link } from "react-router-dom";
import notification from "views/Basic/notification";
import NotificationAlert from "react-notification-alert";

import { get_entries_id } from "stores_api/entries_id";
import CKEditor from "@ckeditor/ckeditor5-react";

// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import BalloonEditor from "@ckeditor/ckeditor5-editor-balloon/src/ballooneditor";
import BlockToolbar from "@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar";
// import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment.js";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat.js";
import Autolink from "@ckeditor/ckeditor5-link/src/autolink.js";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave.js";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote.js";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold.js";
import Code from "@ckeditor/ckeditor5-basic-styles/src/code.js";
import CodeBlock from "@ckeditor/ckeditor5-code-block/src/codeblock.js";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials.js";
import ExportToPDF from "@ckeditor/ckeditor5-export-pdf/src/exportpdf.js";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor.js";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily.js";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize.js";
import Heading from "@ckeditor/ckeditor5-heading/src/heading.js";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight.js";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline.js";
import Image from "@ckeditor/ckeditor5-image/src/image.js";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption.js";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize.js";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle.js";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar.js";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload.js";
import Indent from "@ckeditor/ckeditor5-indent/src/indent.js";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock.js";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic.js";
import Linkckeditor5 from "@ckeditor/ckeditor5-link/src/link.js";
import List from "@ckeditor/ckeditor5-list/src/list.js";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed.js";
import MediaEmbedToolbar from "@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar.js";
import Mention from "@ckeditor/ckeditor5-mention/src/mention.js";
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak.js";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph.js";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat.js";
import SpecialCharacters from "@ckeditor/ckeditor5-special-characters/src/specialcharacters.js";
import SpecialCharactersArrows from "@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows.js";
import SpecialCharactersCurrency from "@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency.js";
import SpecialCharactersEssentials from "@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials.js";
import SpecialCharactersLatin from "@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin.js";
import SpecialCharactersMathematical from "@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical.js";
import SpecialCharactersText from "@ckeditor/ckeditor5-special-characters/src/specialcharacterstext.js";
import StandardEditingMode from "@ckeditor/ckeditor5-restricted-editing/src/standardeditingmode.js";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough.js";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript.js";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript.js";
import Tableckeditor5 from "@ckeditor/ckeditor5-table/src/table.js";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar.js";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation.js";
import Title from "@ckeditor/ckeditor5-heading/src/title.js";
import TodoList from "@ckeditor/ckeditor5-list/src/todolist";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline.js";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount.js";

export function ContainerBlogDetail({ scrollTo, ph }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const entries_id = useSelector((state) => state.entries_id);
  const inLoading = entries_id.isFetching || entries_id.isLoading;

  const { uuid } = useParams();
  const { state } = useLocation();
  const ref = useRef();

  const toast = (inMessage) => {
    notification(ref.current, inMessage);
  };

  // const { content } = state ? state : { content: "" };
  // const { title } = state ? state : { title: "" };
  // const { date } = state ? state : { date: moment() };

  // const post_date = moment
  // .utc(date)
  // .local()
  // .format("YYYY.MM.DD");
  // entry: {entry_id: "325bcd99-0b76-42e6-bbc2-b5f287eaf5f7", title: "dsfsdfsdff",…}
  // content: "<p><span style="color: rgb(103,58,183);">fasdfasdfsdafasdfasdfsdfasdfs</span></p>↵<p><span style="color: rgb(103,58,183);">sfdfsdfd</span><span style="color: rgb(0,188,212);">fdsfsdfsd</span><span style="color: rgb(233,30,99);">fadfasd</span><span style="color: rgb(139,195,74);">fasdfasdfasddfasdf</span><span style="color: rgb(255,87,34);">dsfasdf</span><span style="color: rgb(255,193,7);">sasa</span></p>↵<p><span style="color: rgb(255,193,7);">asf</span></p>↵<p><span style="color: rgb(255,193,7);">a</span></p>"
  // entry_id: "325bcd99-0b76-42e6-bbc2-b5f287eaf5f7"
  // post_date: "2020-07-15T15:00:00.000Z"
  // title: "dsfsdfsdff"

  const editorConfiguration = {
    plugins: [
      Alignment,
      // Autoformat,
      Autolink,
      Autosave,
      BlockQuote,
      BlockToolbar,
      Bold,
      Code,
      CodeBlock,
      Essentials,
      ExportToPDF,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      Heading,
      Highlight,
      HorizontalLine,
      Image,
      ImageCaption,
      ImageResize,
      ImageStyle,
      ImageToolbar,
      ImageUpload,
      Indent,
      IndentBlock,
      Italic,
      Linkckeditor5,
      List,
      MediaEmbed,
      MediaEmbedToolbar,
      Mention,
      PageBreak,
      Paragraph,
      PasteFromOffice,
      RemoveFormat,
      // SimpleUploadAdapter,
      SpecialCharacters,
      SpecialCharactersArrows,
      SpecialCharactersCurrency,
      SpecialCharactersEssentials,
      SpecialCharactersLatin,
      SpecialCharactersMathematical,
      SpecialCharactersText,
      StandardEditingMode,
      Strikethrough,
      Subscript,
      Superscript,
      Tableckeditor5,
      TableCellProperties,
      TableProperties,
      TableToolbar,
      TextTransformation,
      // Title,
      TodoList,
      Underline,
      WordCount,
    ],
    // extraPlugins: [this.CustomUploadAdapterPlugin],
    language: "ja",
    blockToolbar: [
      "bold",
      "italic",
      "link",
      "heading",
      "blockQuote",
      "imageUpload",
      "indent",
      "outdent",
      "numberedList",
      "bulletedList",
      "mediaEmbed",
      "insertTable",
      "alignment",
      "code",
      "codeBlock",
      "exportPdf",
      "fontBackgroundColor",
      "fontSize",
      "fontColor",
      "fontFamily",
      "highlight",
      "horizontalLine",
      "MathType",
      "ChemType",
      "pageBreak",
      "removeFormat",
      "superscript",
      "specialCharacters",
      "strikethrough",
      "subscript",
      "todoList",
      "underline",
      "restrictedEditingException",
      "undo",
      "redo",
    ],
    toolbar: [
      "bold",
      "italic",
      "link",
      "heading",
      "blockQuote",
      "imageUpload",
      "indent",
      "outdent",
      "numberedList",
      "bulletedList",
      "mediaEmbed",
      "insertTable",
      "alignment",
      "code",
      "codeBlock",
      "exportPdf",
      "fontBackgroundColor",
      "fontSize",
      "fontColor",
      "fontFamily",
      "highlight",
      "horizontalLine",
      "MathType",
      "ChemType",
      "pageBreak",
      "removeFormat",
      "superscript",
      "specialCharacters",
      "strikethrough",
      "subscript",
      "todoList",
      "underline",
      "restrictedEditingException",
      "undo",
      "redo",
    ],
    image: {
      toolbar: ["imageTextAlternative", "imageStyle:full", "imageStyle:side"],
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties",
      ],
    },
    // restrictedEditing: {
    //   allowedCommands: ["bold"],
    // },
    // simpleUpload: {
    //   uploadUrl: 'http://example.com',
    //   withCredentials: true,
    //   headers: {
    //     'X-CSRF-TOKEN': 'CSFR-Token',
    //     Authorization: 'Bearer <JSON Web Token>'
    //   }
    // }
  };

  useEffect(() => {
    dispatch(
      get_entries_id({
        data: {
          entry_id: uuid,
        },
        toast,
        page: () => {
          ph();
        },
      })
    );
  }, []);

  if (inLoading) {
    return null;
  } else {
    const entry =
      entries_id && entries_id.entry
        ? entries_id.entry
        : { content: "", entry_id: "", post_date: "", title: "" };

    const content = entry.content;
    const title = entry.title;
    const post_date = entry.post_date;
    const date = moment.utc(post_date).local().format("YYYY.MM.DD");

    const next_id = entry.next ? entry.next.entry_id : "";
    const prev_id = entry.prev ? entry.prev.entry_id : "";

    const next_title = entry.next ? entry.next.title : "";
    const prev_title = entry.prev ? entry.prev.title : "";
    // BalloonEditor.ReadOnly = true;
    return (
      <>
        <div className="rna-container">
          <NotificationAlert ref={ref} />
        </div>

        <Container className="pb-5">
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              <h2 className="title">{title}</h2>
              <h4 className="card-category text-default">{date}</h4>
              {/* <h6 className="title-uppercase">{date}</h6> */}
              {/* <h5 className="description">
                  どんな小さなことでも構いません。是非、弊社にご相談ください。
                </h5> */}
            </Col>
          </Row>
          <div className="space-top" />

          <Row>
            <Col lg="12">
              <div className="pull-left">
                {prev_title ? (
                  <Button
                    style={{ fontSize: 15 }}
                    className="btn-link btn-move-left"
                    color="default"
                    size="sm"
                    onClick={() => {
                      dispatch(
                        get_entries_id({
                          data: {
                            entry_id: prev_id,
                          },
                          page: () => {
                            ph();
                          },
                        })
                      );
                      scrollTo();
                    }}
                  >
                    <Link
                      onClick={() => {
                        scrollTo();
                      }}
                      to={{
                        pathname: `/blog/${prev_id}`,
                      }}
                      activeClassName="active"
                    >
                      <i className="fa fa-angle-left mr-1" />
                      {prev_title}
                    </Link>
                  </Button>
                ) : null}
              </div>
              <div className="pull-right">
                {next_title ? (
                  <Button
                    style={{ fontSize: 15 }}
                    className="btn-link btn-move-right"
                    color="default"
                    size="sm"
                    onClick={() => {
                      dispatch(
                        get_entries_id({
                          data: {
                            entry_id: next_id,
                          },
                          page: () => {
                            ph();
                          },
                        })
                      );
                      scrollTo();
                    }}
                  >
                    <Link
                      onClick={() => {
                        scrollTo();
                      }}
                      to={{
                        pathname: `/blog/${next_id}`,
                      }}
                      activeClassName="active"
                    >
                      {next_title}
                      <i className="fa fa-angle-right" />
                    </Link>
                  </Button>
                ) : null}
              </div>
            </Col>
          </Row>
          <hr />

          {/* <div style={{ minHeight: "100vh" }}>
                <div
                  id="login_duration_description"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div> */}
          <CKEditor
            editor={BalloonEditor}
            config={editorConfiguration}
            disabled={true}
            // readOnly={true}
            // data="<h2>Taj Mahal: A breathtaking ode to love</h2><figure class='image ck-widget ck-widget_with-resizer image-style-side' contenteditable='false'><img src='https://ckeditor.com/assets/images/bg/tajmahal-b15aed2c99.jpg' alt='Taj Mahal illustration.'><div class='ck ck-reset_all ck-widget__type-around'><div class='ck ck-widget__type-around__button ck-widget__type-around__button_before' title='Insert paragraph before block'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 8'><polyline points='8.05541992 0.263427734 8.05541992 4.23461914 1.28417969 4.23461914' transform='translate(1,0)'></polyline><line x1='0' y1='4.21581031' x2='2' y2='2.17810059' transform='translate(1, 0)'></line><line x1='0' y1='6.21581031' x2='2' y2='4.17810059' transform='translate(2, 5.196955) scale(1, -1) translate(-1, -5.196955)'></line></svg></div><div class='ck ck-widget__type-around__button ck-widget__type-around__button_after' title='Insert paragraph after block'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 8'><polyline points='8.05541992 0.263427734 8.05541992 4.23461914 1.28417969 4.23461914' transform='translate(1,0)'></polyline><line x1='0' y1='4.21581031' x2='2' y2='2.17810059' transform='translate(1, 0)'></line><line x1='0' y1='6.21581031' x2='2' y2='4.17810059' transform='translate(2, 5.196955) scale(1, -1) translate(-1, -5.196955)'></line></svg></div><div class='ck ck-widget__type-around__fake-caret'></div></div><div class='ck ck-reset_all ck-widget__resizer' style='display: none;'><div class='ck-widget__resizer__handle ck-widget__resizer__handle-top-left'></div><div class='ck-widget__resizer__handle ck-widget__resizer__handle-top-right'></div><div class='ck-widget__resizer__handle ck-widget__resizer__handle-bottom-right'></div><div class='ck-widget__resizer__handle ck-widget__resizer__handle-bottom-left'></div><div class='ck ck-size-view' style='display: none;'></div></div><figcaption class='ck-editor__editable ck-editor__nested-editable' data-placeholder='Enter image caption' contenteditable='true'>Taj Mahal with its poetic white marble tomb</figcaption></figure><p>No trip to India is complete without visiting this spectacular monument, <a href='https://en.wikipedia.org/wiki/New7Wonders_of_the_World'><strong>counted among the Seven Wonders of the World</strong></a>.</p><p>Tourists frequently admit that Taj Mahal 'simply cannot be described with words'. And that’s probably true. The more you try the more speechless you become. Words give only a semblance of truth. The real truth about its beauty is revealed when you adore <strong>different shades of “Taj” depending on the time of the day</strong> or when you admire the exquisite inlay work in different corners of the façade.</p><h3>Masterpiece of the world’s heritage</h3><p>Taj Mahal is a mausoleum built in Agra between 1631 and 1648 by Emperor Shah Jahan <strong>in the memory of his beloved wife</strong>, Mumtaz Mahal, whose body lies there. It took 20 000 workers to complete and the excellence of this building is visible in every brick.</p><p>In 1983, Taj Mahal was appointed <a href='https://en.wikipedia.org/wiki/World_Heritage_Site'>UNESCO World Heritage Site</a> for being 'the jewel of Muslim art in India and one of the universally admired masterpieces of the world's heritage'.</p><p>If you like having a methodology for visiting historical places, here are the four elements on which we recommend to focus your attention:</p><ul><li>The tomb</li><li>The Decorations</li><li>The Garden</li><li>The Outlying buildings</li></ul><p>The tomb is what immediately catches your eyesight. The <strong>white and soft marble</strong> embroidered with stones leaves you totally enchanted.</p>"
            data={content}
          />

          <hr />
          <Row>
            <Col lg="12">
              <div className="pull-left">
                {prev_title ? (
                  <Button
                    style={{ fontSize: 15 }}
                    className="btn-link btn-move-left"
                    color="default"
                    size="sm"
                    // onClick={(e) => {
                    //   history.push({
                    //     pathname: `/blog/`,
                    //     pathname: `/blog/${prop.entry_id}`,
                    //     state: { content: prop.content ,title:prop.title,date:post_date},
                    //   });
                    // }}
                    onClick={() => {
                      dispatch(
                        get_entries_id({
                          data: {
                            entry_id: prev_id,
                          },
                          page: () => {
                            ph();
                          },
                        })
                      );
                      scrollTo();
                    }}
                  >
                    <Link
                      onClick={() => {
                        scrollTo();
                      }}
                      to={{
                        pathname: `/blog/${prev_id}`,
                      }}
                      activeClassName="active"
                    >
                      <i className="fa fa-angle-left mr-1" />
                      {prev_title}
                    </Link>
                  </Button>
                ) : null}
              </div>
              <div className="pull-right">
                {next_title ? (
                  <Button
                    style={{ fontSize: 15 }}
                    className="btn-link btn-move-right"
                    color="default"
                    size="sm"
                    onClick={() => {
                      dispatch(
                        get_entries_id({
                          data: {
                            entry_id: next_id,
                          },
                          page: () => {
                            ph();
                          },
                        })
                      );
                      scrollTo();
                    }}
                  >
                    <Link
                      onClick={() => {
                        scrollTo();
                      }}
                      to={{
                        pathname: `/blog/${next_id}`,
                      }}
                      activeClassName="active"
                    >
                      {next_title}
                      <i className="fa fa-angle-right" />
                    </Link>
                  </Button>
                ) : null}
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default ContainerBlogDetail;
